import React from 'react';
import { motion } from 'framer-motion';
import Button from '../../components/ui/Button';
import ParallaxHero from '../../components/ui/ParallaxHero';

const Hero = () => (
  <ParallaxHero
    image="https://media-manager-c.questera.ai/greta-media/8c84f85263efda659889de32f1f32e795be69e9a2504f254db44deecf03d5d2eaf8d8138b6c4ad97d7d004f4d5618742/images/aW1hZ2UvcG5n/c8e44d59a4e812fc499ebd3f1cc275f0.png"
    tag="The Business Code — Feminine Leadership"
    title="Hör auf zu kämpfen. Fang an zu magnetisieren."
    titleHighlight="magnetisieren."
    subtitle="Steige aus dem maskulinen Hustle aus. Skaliere dein Erbe in unentschuldigter Queen-Energie."
    accentColor="rgba(212,175,55,0.1)"
  >
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, delay: 2 }}
      className="flex flex-col sm:flex-row gap-6 justify-center mt-4"
    >
      <Button variant="gold" className="shadow-[0_0_30px_rgba(212,175,55,0.3)]">
        Dein Quantum Leap beginnt hier
      </Button>
    </motion.div>
  </ParallaxHero>
);

export default Hero;